<template>
  <!--    园区活动详情-->
  <div class="garden_activity_details">
    <div class="breadcrumb m">
      <el-breadcrumb separator-class="el-icon-caret-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/garden_activity' }">园区活动</el-breadcrumb-item>
        <el-breadcrumb-item>活动详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="parkSwitch" v-if="parkInfo">
        当前园区：
        {{parkInfo.name}} - {{company}}
        <a href="javascript:;" @click="dialogParams2.dialogVisible = true">切换园区</a>
      </div>
    </div>
    <div class="m">
      <div class="left_box">

        <div class="message_box">
          <div class="img_box">
            <img v-lazy="activity_detail.coverPath" />
            <div class="incubator">{{activity_detail.incubator_name}}</div>
          </div>
          <div class="message_inner_box">
            <h3>
              <el-tag style="vertical-align: text-bottom;">{{activity_detail.type_name}}</el-tag>
              &nbsp;{{ activity_detail.name }}
            </h3>
            <div class="collection_box">
              <div @click="collectionActivity" :class="{collected:activity_detail.isCollection}">
                <template v-if="!activity_detail.isCollection">
                  <i class="el-icon-star-off"></i>
                  <span>收藏</span>
                </template>
                <template v-else>
                  <i class="el-icon-star-on"></i>
                  <span>已收藏</span>
                </template>
              </div>
            </div>
            <div class="msgDetails_box">
              <div class="msgDetails_box_li">
                <span>
                  <i class="el-icon-time" />活动时间：
                </span>
                <span>{{ activity_detail.start_date }} 至 {{ activity_detail.end_date }}</span>
              </div>
              <div class="msgDetails_box_li">
                <span>
                  <i class="el-icon-time" />报名截止：
                </span>
                <span>{{ activity_detail.end_sign_date }}</span>
              </div>
              <div class="msgDetails_box_li">
                <span>
                  <i class="el-icon-location-outline" />活动地点：
                </span>
                <span>{{ activity_detail.province_name }}{{ activity_detail.city_name }}{{ activity_detail.county_name }}{{ activity_detail.address }}</span>
              </div>
              <div class="msgDetails_box_li" v-if="activity_detail.price">
                <span>
                  <i class="el-icon-coin" />报名费用：
                </span>
                <span>{{ activity_detail.price }}</span>
              </div>
            </div>
            <div class="btn_box">
              <div class="enroll_box">
                <!-- 未报名 -->
                <template v-if="!activity_detail.is_enlist">
                  <el-button v-if="!!activity_detail.is_end_sign">报名结束</el-button>
                  <el-button @click="enroll" v-else>报名中</el-button>
                </template>
                <!-- 已报名 -->
                <el-button v-else disabled>已报名</el-button>
              </div>
              <div class="heat_box">
                <span>
                  <i class="el-icon-view" />
                  {{ activity_detail.browse }}人浏览
                </span>
                <span>
                  <i class="el-icon-star-off" />
                  {{ activity_detail.collection_count }}人收藏
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="details_box">
          <h3 class="details_title">
            <span>详情介绍</span>
          </h3>
          <template v-if="activity_detail.guidance">
            <h4 class="details_small_title">指导单位</h4>
            <div class="detail_cont">{{activity_detail.guidance}}</div>
          </template>
          <template v-if="activity_detail.sponsor">
            <h4 class="details_small_title">主办单位</h4>
            <div class="detail_cont">{{activity_detail.sponsor}}</div>
          </template>

          <template v-if="activity_detail.company">
            <h4 class="details_small_title">承办单位</h4>
            <div class="detail_cont">{{activity_detail.company}}</div>
          </template>
          <template v-if="activity_detail.contact || activity_detail.contact_phone || activity_detail.contact_mobile">
            <h4 class="details_small_title">联系方式</h4>
            <div class="detail_cont" v-if="activity_detail.contact">联系人：{{activity_detail.contact}}</div>
            <div
              class="detail_cont"
              v-if="activity_detail.contact_phone"
            >电话：{{activity_detail.contact_phone}}</div>
            <div
              class="detail_cont"
              v-if="activity_detail.contact_mobile"
            >手机：{{activity_detail.contact_mobile}}</div>
            <div
              class="detail_cont"
              v-if="activity_detail.contact_email"
            >邮箱：{{activity_detail.contact_email}}</div>
            <div
              class="detail_cont"
              v-if="activity_detail.contact_qq"
            >QQ：{{activity_detail.contact_qq}}</div>
          </template>

          <h4 class="details_small_title">活动详情</h4>
          <div class="ck-text" v-if="activity_detail.content_type === 10">
            <div v-html="activity_detail.content"></div>
          </div>
          <div class="detail_cont" v-else>
            <a
              v-if="activity_detail.jump_link"
              :href="activity_detail.jump_link"
              target="_blank"
              style="color:#4C84FF;"
            >点击查看</a>
          </div>
          <h4 class="details_small_title">报名须知</h4>
          <div class="ck-text">
            <div v-html="activity_detail.notice"></div>
          </div>
          <template v-if="activity_detail.filePath">
            <h4 class="details_small_title">附件</h4>
            <div class="file">
              <a :href="activity_detail.filePath" download="activity_detail.filePath">查看附件</a>
            </div>
          </template>
        </div>
      </div>
      <!-- 热门活动列表 -->
      <div class="right_box">
        <div class="float_box">
          <h3>热门活动</h3>
          <ul>
            <li v-for="(item,index) in hotActivities" :key="index">
              <router-link :to="`/garden_activity_details?code=${item.code}`" target="_blank">
                <div>
                  <img v-lazy="item.coverPath" />
                </div>
                <div>
                  <p>{{ item.name }}</p>
                  <span>{{ item.start_date }}</span>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <changeParkconfirm :params="params"></changeParkconfirm>
      <!-- 报名 -->
      <activityApply :params="activity_detail" :activeForms="activeForms" :dialogParams="dialogParams"></activityApply>
      <!-- 切换园区 -->
      <switchPark :dialogParams="dialogParams2" />
    </div>
  </div>
</template>

<script>
import changeParkconfirm from "@/components/dialog/changeParkconfirm.vue";
import activityApply from "@/components/dialog/activityApply.vue";
import switchPark from "@/components/dialog/switchPark.vue";
export default {
  name: "index",
  components: {
    changeParkconfirm,
    activityApply,
    switchPark
  },
  data() {
    return {
      activity_detail: {}, // 活动详情
      activeForms:[],//自定义表单
      ruleForm: {
        company: "", //公司
        contact: "", //姓名
        contact_phone: "", //手机
        simple_name: "", // 昵称
        contact_email: "" // 邮箱
      },
      hotActivities: [], //热门活动
      code: "", //活动code
      params: {
        dialogVisible: false
      },
      dialogParams: {
        dialogVisible: false
      },
      dialogParams2: {
        dialogVisible: false
      }
    };
  },
  created() {
    // 活动code
    this.code = this.$route.query.code;
    /* 获取活动详情 */

    this.getActives();
    // 获取热门活动
    this.getHotActive();
    if (this.info) {
      // this.getEnterpriseInfo();
      this.common.getEnterpriseInfo();
    } else {
      this.needInfo("getEnterpriseInfo");
    }
  },
  computed: {
    // 个人信息
    info() {
      return this.$store.state.info;
    },
    // 园区信息
    parkInfo() {
      return this.$store.state.parkInfo;
    },
    // 企业信息
    company() {
      return this.$store.state.company;
    },
  },
  methods: {
    /* 获取活动详情 */

    getActives() {
      this.api.getActives({ id: this.$route.query.id }).then(res => {
        if (res.error.err_code != 0) return;
        let obj = res.obj.list.length?res.obj.list[0]:{};
        obj.activeForms.forEach(item=>{
          item.option = JSON.parse(item.option||'[]')
          if(item.types === 40){
            item.value = [];
          }else{
            item.value = '';
          }
        })
        this.activeForms = obj.activeForms;
        this.activity_detail = obj;
      });
    },
    // 我要报名
    enroll() {
      // this.dialogParams.dialogVisible = true;
      //限制园区内报名
      if (this.activity_detail.is_limit_incubator) {
        if (!this.info) {
          this.login(); //去登录
        } else if (this.info && !this.parkInfo) {
          this.bindPark(); //绑定园区
        } else if (this.activity_detail.incubator_id !== this.parkInfo.id) {
          // this.changePark() //切换园区
          // this.params.dialogVisible = true;
          this.dialogParams2.dialogVisible = true;
        } else {
          this.userVerify();
        }
      } else {
        if (!this.info) {
          this.login(); //去登录
        } else if (this.info && !this.parkInfo) {
          this.bindPark(); //绑定园区
        } else {
          this.userVerify();
        }
      }
    },
    // 活动校验
    userVerify() {
      // 活动报名弹窗改为新页面打开
      // this.dialogParams.dialogVisible = true;
      this.$router.push({
        name:'garden_activity_sing',
        query:{
          id:this.activity_detail.id
        }
      })
    },
    // 绑定园区
    bindPark() {
      this.$confirm("您还未绑定园区，是否前往绑定？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$router.push({
            name: "changeEnterprise"
          });
        })
        .catch(() => {
          return;
        });
    },
    // 去登录
    login() {
      this.$confirm("是否前往登录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$router.push({
            name: "login"
          });
        })
        .catch(() => {
          return;
        });
    },

    // 点击收藏或者取消收藏
    collectionActivity() {
      if (!this.activity_detail.isCollection) {
        // 收藏
        this.createFrontCollection();
      } else {
        // 取消收藏
        this.deleteFrontCollection();
      }
    },
    // 收藏
    createFrontCollection() {
      let obj = {
        type: "CollectionTypeActivity",
        // user_id : this.$store.state.info.id,
        code: this.activity_detail.code
      };
      this.api.createFrontCollection(obj).then(res => {
        // console.log(res.error.err_msg);
        if (res.error.err_code !== 0) return;
        this.$message({
          message: "收藏成功！",
          type: "success"
        });
        this.getActives();
      });
    },
    // 取消收藏
    deleteFrontCollection() {
      this.api
        .deleteFrontCollection({ code: this.activity_detail.code })
        .then(res => {
          if (res.error.err_code != 0) return;
          this.$message({
            message: "您已取消收藏！",
            type: "info"
          });
          this.getActives();
        });
    },

    // 当前选择的企业
    getEnterpriseInfo() {
      this.api.getEnterpriseInfo({}).then(res => {
        if (res.error.err_code != 0) return;
        let list = res.obj.list;
        this.ruleForm.company = list.length ? list[0].name : "";
      });
    },
    // 监听个人信息
    needInfo(name) {
      let watchAch = this.$watch("info", (val, oldVal) => {
        if (val) {
          // this[name]();
          this.common.getEnterpriseInfo();
          watchAch(); //取消监听
        }
      });
    },
    // 获取热门活动
    getHotActive() {
      this.api.getHotActive({ pageSize: 4 }).then(res => {
        if (res.error.err_code != 0) return;
        let list = res.obj.list;
        this.hotActivities = list.length ? list : [];
      });
    }
  }
};
</script>

<style lang="scss">
@import url("../../personal_center/index.scss");
.garden_activity_details {
  .breadcrumb{
    display: flex;
    align-items: center;
    justify-content: space-between;
    .parkSwitch {
      color: #333;
      font-size: 14px;
      a {
        margin-left: 10px;
        color: #4c84ff;
      }
    }
    .el-breadcrumb {
      .el-breadcrumb__inner {
        line-height: 74px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
      }
    }
  }
  .m {
    display: flex;
    justify-content: space-between;
    .left_box {
      flex: 1;
      margin-right: 40px;

      .message_box {
        display: flex;
        background: #fff;
        padding: 30px;
        position: relative;
        .img_box {
          position: relative;
          img {
            width: 304px;
            height: 227px;
            border-radius: 4px;
            background: $bg-darkgray;
          }
          .incubator {
            position: absolute;
            z-index: 1000;
            top: 10px;
            right: 10px;
            width: 120px;
            height: 34px;
            line-height: 34px;
            text-align: center;
            background: rgba(255, 255, 255, 1);
            opacity: 0.8;
            border-radius: 6px;
            padding: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            word-wrap: normal;
          }
        }
        .message_inner_box {
          padding-left: 20px;
          flex: 1;
          margin-top: 10px;
          h3 {
            line-height: 28px;
            font-size: 20px;
            font-weight: bold;
            color: #333;
            max-width: 367px;
          }
          .msgDetails_box {
            .msgDetails_box_li {
              display: flex;
              margin:5px;
              span {
                line-height: 20px;
                font-size: 14px;
                color: #999999;
                i {
                  margin-right: 10px;
                }
              }
              span:nth-child(1) {
                width: 100px;
                flex:none;
              }
              span:nth-child(2) {
              }
            }
          }
          .takeCost {
            line-height: 58px;
            font-size: 18px;
            font-weight: bold;
            color: #ff733c;
          }
          .btn_box {
            position: relative;
            .enroll_box {
              position: relative;
              button {
                margin-top: 45px;
                width: 180px;
                height: 44px;
                background: #4c84ff;
                border-radius: 2px;
                font-size: 16px;
                color: #f0f2f5;
              }
            }
            .heat_box {
              position: absolute;
              right: 0;
              bottom: 6px;
              span {
                line-height: 32px;
                font-size: 12px;
                font-weight: 400;
                color: #9499a5;
                i {
                  margin-right: 6px;
                }
              }
              span + span {
                margin-left: 20px;
              }
            }
          }
        }
        .collection_box {
          position: absolute;
          top: 45px;
          right: 30px;
          cursor: pointer;
          span {
            color: rgba(102, 102, 102, 1);
          }
          i {
            color: rgba(76, 132, 255, 1);
          }
          .collected {
            span,
            i {
              color: rgba(76, 132, 255, 1);
            }
          }
        }
      }
      .details_box {
        background: #fff;
        margin-top: 20px;
        padding-bottom: 30px;
        .details_title {
          line-height: 60px;
          padding-left: 30px;
          border-bottom: 1px solid #eee;
          span {
            font-size: 14px;
            color: #4c84ff;
            position: relative;
            display: inline-block;
            line-height: 60px;
          }
          span::after {
            content: "";
            width: 56px;
            height: 2px;
            background: #4c84ff;
            position: absolute;
            right: 0;
            left: 0;
            margin: 0 auto;
            bottom: 0;
          }
        }
        .details_small_title {
          padding: 30px 0 10px 30px;
          font-size: 16px;
          font-weight: bold;
          color: #4b5062;
        }

        .detail_cont,
        .ck-text {
          padding: 0 30px;
        }
        .detail_cont {
          line-height: 20px;
        }
        .file{
          padding: 0 30px;
          a{
            color: #4c84ff;
          }
        }
      }
      .notes_application {
        .notes_title {
          font-size: 20px;
          font-weight: bold;
          color: #333333;
          line-height: 80px;
        }
      }
      .el-dialog__wrapper {
        .el-dialog {
          width: 580px;
          .el-dialog__body {
            .el-row {
              .el-col {
                margin-right: 22px;
                .el-input {
                  width: 246px;
                }
              }
            }
          }
          .el-dialog__footer {
            .dialog-footer {
              text-align: center;
            }
          }
        }
      }
    }
    .right_box {
      .float_box {
        background: #fff;
        border-radius: 4px;
        box-sizing: border-box;
        padding: 0px 10px 0px 20px;
        width: 300px;
        h3 {
          font-size: 14px;
          color: #333;
          line-height: 50px;
        }
        ul {
          padding-bottom: 10px;
          li:hover {
            p {
              color: #4c84ff !important;
            }
          }
          li {
            margin-bottom: 10px;
            a {
              padding-bottom: 10px;
              display: flex;
            }
            div:nth-child(1) {
              width: 90px;
              height: 68px;
              border-radius: 4px;
              img {
                width: 100%;
                height: 100%;
                background: $bg-darkgray;
              }
            }
            div:nth-child(2) {
              flex: 1;
              padding: 0 0 0 10px;
              p {
                font-size: 14px;
                color: #333;
                line-height: 20px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
              }
              span {
                font-size: 12px;
                color: #999;
                margin-top: 16px;
                display: block;
              }
            }
          }
        }
      }
    }
  }
}
</style>
